module.exports = __webpack_public_path__ + "static/media/44487737_2199892510085928_2061614976736428032_o.bd80e52d.jpg";